import React from 'react';

const NewsTicker = () => {
  const tickerItems = [
    "We are in Beta!",
    "No token or collection have been released yet.",
    "Check Alice's latest news on X!"
  ];

  // Join all items with separator
  const tickerText = tickerItems.join("   •   ");

  return (
    <div className="w-full bg-black/80 border-y border-fuchsia-600/30 overflow-hidden">
      <div className="flex items-center py-2">
        <div className="text-fuchsia-400 font-bold px-4 whitespace-nowrap">
          BREAKING:
        </div>
        <div className="ticker-scroll-container overflow-hidden">
          <div className="ticker-animation">
            {tickerText}
          </div>
        </div>
      </div>

      <style jsx>{`
        .ticker-scroll-container {
          width: 100%;
          overflow: hidden;
        }
        .ticker-animation {
          display: inline-block;
          white-space: nowrap;
          padding-left: 100%;
          animation: ticker 20s linear infinite;
          font-family: 'BlenderPro', sans-serif;
          color: white;
        }
        @keyframes ticker {
          0% { transform: translate3d(0, 0, 0); }
          100% { transform: translate3d(-100%, 0, 0); }
        }
      `}</style>
    </div>
  );
};

export default NewsTicker;